import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "exam-results-view" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "border-b border-gray-200 dark:border-gray-700" }
const _hoisted_4 = {
  class: "-mb-px flex space-x-8",
  "aria-label": "Tabs"
}
const _hoisted_5 = { class: "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 mb-4 shadow-sm" }
const _hoisted_6 = { class: "flex flex-col lg:flex-row lg:items-end gap-4" }
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_10 = ["min", "disabled"]
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = { class: "grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-2" }
const _hoisted_13 = { class: "flex items-end" }
const _hoisted_14 = {
  key: 0,
  class: "mt-3 pt-3 border-t border-gray-200 dark:border-gray-700"
}
const _hoisted_15 = { class: "flex items-center gap-2 text-sm" }
const _hoisted_16 = { class: "px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-md font-medium" }
const _hoisted_17 = { class: "text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700" }
const _hoisted_20 = { class: "px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_21 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" }
const _hoisted_22 = { class: "flex items-center gap-3" }
const _hoisted_23 = { class: "px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full text-xs font-medium" }
const _hoisted_24 = { class: "w-full sm:w-64" }
const _hoisted_25 = {
  key: 0,
  class: "p-8 text-center"
}
const _hoisted_26 = {
  key: 1,
  class: "p-8 text-center"
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "hidden xl:block overflow-x-auto" }
const _hoisted_29 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_30 = { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_34 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_35 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_36 = { class: "px-6 py-4" }
const _hoisted_37 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_38 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400"
}
const _hoisted_39 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_40 = { class: "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300" }
const _hoisted_41 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_42 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_43 = { class: "text-sm text-primary-text dark:text-primary-dark-text" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  colspan: "6",
  class: "px-6 py-0"
}
const _hoisted_46 = { class: "bg-gray-50 dark:bg-gray-900/50 rounded-lg p-4 my-2" }
const _hoisted_47 = { class: "space-y-3" }
const _hoisted_48 = { class: "flex items-start justify-between" }
const _hoisted_49 = { class: "flex items-center gap-3 w-full" }
const _hoisted_50 = { class: "flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-semibold text-sm flex-shrink-0" }
const _hoisted_51 = { class: "grid grid-cols-5 gap-6 flex-1" }
const _hoisted_52 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_53 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_54 = { class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300" }
const _hoisted_55 = { class: "text-sm text-primary-text dark:text-primary-dark-text" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "xl:hidden divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "p-4" }
const _hoisted_60 = { class: "flex items-start justify-between mb-3" }
const _hoisted_61 = { class: "flex-1" }
const _hoisted_62 = { class: "text-base font-semibold text-primary-text dark:text-primary-dark-text mb-1" }
const _hoisted_63 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_64 = { class: "mb-3" }
const _hoisted_65 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text mb-1" }
const _hoisted_66 = {
  key: 0,
  class: "text-xs text-secondary-text dark:text-secondary-dark-text"
}
const _hoisted_67 = { class: "space-y-2 text-sm" }
const _hoisted_68 = { class: "flex justify-between items-center" }
const _hoisted_69 = { class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300" }
const _hoisted_70 = { class: "flex justify-between items-center" }
const _hoisted_71 = { class: "flex justify-between" }
const _hoisted_72 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_73 = {
  key: 0,
  class: "mt-3 space-y-3"
}
const _hoisted_74 = { class: "flex items-center gap-2 mb-3 pb-3 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_75 = { class: "flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-semibold text-sm" }
const _hoisted_76 = { class: "space-y-2.5 text-sm" }
const _hoisted_77 = { class: "flex justify-between items-center" }
const _hoisted_78 = { class: "text-right" }
const _hoisted_79 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_80 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_81 = { class: "flex justify-between items-center" }
const _hoisted_82 = { class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300" }
const _hoisted_83 = { class: "flex justify-between items-center" }
const _hoisted_84 = { class: "flex justify-between" }
const _hoisted_85 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_86 = { class: "flex justify-end pt-3 mt-3 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = {
  key: 3,
  class: "px-4 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700"
}
const _hoisted_89 = { class: "flex items-center justify-between" }
const _hoisted_90 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700" }
const _hoisted_93 = { class: "px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_94 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" }
const _hoisted_95 = { class: "flex items-center gap-3" }
const _hoisted_96 = { class: "px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full text-xs font-medium" }
const _hoisted_97 = { class: "w-full sm:w-64" }
const _hoisted_98 = {
  key: 0,
  class: "p-8 text-center"
}
const _hoisted_99 = {
  key: 1,
  class: "p-8 text-center"
}
const _hoisted_100 = { key: 2 }
const _hoisted_101 = { class: "hidden xl:block overflow-x-auto" }
const _hoisted_102 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_103 = { class: "bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_106 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_107 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_108 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_109 = { class: "px-6 py-4" }
const _hoisted_110 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_111 = {
  key: 0,
  class: "text-xs text-gray-500 dark:text-gray-400"
}
const _hoisted_112 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_113 = { class: "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300" }
const _hoisted_114 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_115 = { class: "text-sm text-primary-text dark:text-primary-dark-text" }
const _hoisted_116 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_117 = {
  key: 0,
  class: "text-sm text-primary-text dark:text-primary-dark-text"
}
const _hoisted_118 = {
  key: 1,
  class: "text-sm text-gray-500 dark:text-gray-400"
}
const _hoisted_119 = { key: 0 }
const _hoisted_120 = {
  colspan: "6",
  class: "px-6 py-0"
}
const _hoisted_121 = { class: "bg-gray-50 dark:bg-gray-900/50 rounded-lg p-4 my-2" }
const _hoisted_122 = { class: "space-y-3" }
const _hoisted_123 = { class: "flex items-start justify-between" }
const _hoisted_124 = { class: "flex items-center gap-3 w-full" }
const _hoisted_125 = { class: "flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-semibold text-sm flex-shrink-0" }
const _hoisted_126 = { class: "grid grid-cols-4 gap-6 flex-1" }
const _hoisted_127 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_128 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_129 = { class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300" }
const _hoisted_130 = { class: "text-sm text-primary-text dark:text-primary-dark-text" }
const _hoisted_131 = { class: "xl:hidden divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = { class: "p-4" }
const _hoisted_134 = { class: "flex items-start justify-between mb-3" }
const _hoisted_135 = { class: "flex-1" }
const _hoisted_136 = { class: "text-base font-semibold text-primary-text dark:text-primary-dark-text mb-1" }
const _hoisted_137 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_138 = { class: "mb-3" }
const _hoisted_139 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text mb-1" }
const _hoisted_140 = {
  key: 0,
  class: "text-xs text-secondary-text dark:text-secondary-dark-text"
}
const _hoisted_141 = { class: "space-y-2 text-sm" }
const _hoisted_142 = { class: "flex justify-between items-center" }
const _hoisted_143 = { class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300" }
const _hoisted_144 = { class: "flex justify-between" }
const _hoisted_145 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_146 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_147 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_148 = {
  key: 0,
  class: "mt-3 space-y-3"
}
const _hoisted_149 = { class: "flex items-center gap-2 mb-3 pb-3 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_150 = { class: "flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 font-semibold text-sm" }
const _hoisted_151 = { class: "space-y-2.5 text-sm" }
const _hoisted_152 = { class: "flex justify-between items-center" }
const _hoisted_153 = { class: "text-right" }
const _hoisted_154 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_155 = { class: "text-xs text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_156 = { class: "flex justify-between items-center" }
const _hoisted_157 = { class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300" }
const _hoisted_158 = { class: "flex justify-between items-center" }
const _hoisted_159 = { class: "flex justify-between" }
const _hoisted_160 = { class: "text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_161 = {
  key: 3,
  class: "px-4 sm:px-6 py-4 border-t border-gray-200 dark:border-gray-700"
}
const _hoisted_162 = { class: "flex items-center justify-between" }
const _hoisted_163 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }

import { ref, computed, onMounted, watch } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { examResultService } from '@/services/examResultService'
import type { ExamResult, ExamAttemptHistory } from '@/services/examResultService'
import BaseButton from '@/components/common/BaseButton.vue'
import { ClipboardList, Eye, Calendar, X, History, Archive } from 'lucide-vue-next'
import { useRouter } from 'vue-router'

// Page title
interface GroupedExamResult {
  key: string
  employeeId: number
  examId: number
  latestResult: ExamResult
  results: ExamResult[]
}

interface GroupedAttempt {
  key: string
  resetDate: string
  resetDateFormatted: string
  resetBy: any
  attempts: ExamAttemptHistory[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultsView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')
useTitle(`Exam Results - ${appTitle.value}`)

const router = useRouter()
const loading = ref(false)
const examResults = ref<ExamResult[]>([])
const expandedCurrentGroups = ref<Set<string>>(new Set())
const currentSearchQuery = ref('')

// Load active tab from localStorage
const loadActiveTabFromStorage = (): 'current' | 'history' => {
  try {
    const savedTab = localStorage.getItem('examResultsActiveTab')
    if (savedTab === 'current' || savedTab === 'history') {
      return savedTab
    }
  } catch (error) {
    console.error('Failed to load active tab from localStorage:', error)
  }
  return 'current'
}

// Save active tab to localStorage
const saveActiveTabToStorage = (tab: 'current' | 'history') => {
  try {
    localStorage.setItem('examResultsActiveTab', tab)
  } catch (error) {
    console.error('Failed to save active tab to localStorage:', error)
  }
}

// Tab state - initialize from localStorage
const activeTab = ref<'current' | 'history'>(loadActiveTabFromStorage())

// Watch for active tab changes and save to localStorage
watch(activeTab, (newValue) => {
  saveActiveTabToStorage(newValue)
})

// Attempt History state
const historyLoading = ref(false)
const attemptHistory = ref<ExamAttemptHistory[]>([])
const expandedGroups = ref<Set<string>>(new Set())
const historySearchQuery = ref('')

// Load date range from localStorage
const loadDateRangeFromStorage = () => {
  try {
    const savedDateRange = localStorage.getItem('examResultsDateRange')
    if (savedDateRange) {
      return JSON.parse(savedDateRange)
    }
  } catch (error) {
    console.error('Failed to load date range from localStorage:', error)
  }
  return { start: '', end: '' }
}

// Save date range to localStorage
const saveDateRangeToStorage = (range: { start: string; end: string }) => {
  try {
    localStorage.setItem('examResultsDateRange', JSON.stringify(range))
  } catch (error) {
    console.error('Failed to save date range to localStorage:', error)
  }
}

// Date range filter state - initialize from localStorage
const dateRange = ref(loadDateRangeFromStorage())

// Load active preset from localStorage
const loadActivePresetFromStorage = (): string | null => {
  try {
    const savedPreset = localStorage.getItem('examResultsActivePreset')
    return savedPreset || null
  } catch (error) {
    console.error('Failed to load active preset from localStorage:', error)
    return null
  }
}

// Save active preset to localStorage
const saveActivePresetToStorage = (preset: string | null) => {
  try {
    if (preset) {
      localStorage.setItem('examResultsActivePreset', preset)
    } else {
      localStorage.removeItem('examResultsActivePreset')
    }
  } catch (error) {
    console.error('Failed to save active preset to localStorage:', error)
  }
}

const activePreset = ref<string | null>(loadActivePresetFromStorage())

// Watch for active preset changes and save to localStorage
watch(activePreset, (newValue) => {
  saveActivePresetToStorage(newValue)
})

// Watch for date range changes and save to localStorage
watch(
  dateRange,
  (newValue) => {
    saveDateRangeToStorage(newValue)
    
    // If "To Date" is before "From Date", clear "To Date"
    if (newValue.start && newValue.end) {
      const startDate = new Date(newValue.start)
      const endDate = new Date(newValue.end)
      if (endDate < startDate) {
        dateRange.value.end = ''
      }
    }
  },
  { deep: true }
)

// Filtered and formatted exam results
const filteredExamResults = computed(() => {
  let filtered = examResults.value

  // Apply date range filter
  if (dateRange.value.start || dateRange.value.end) {
    filtered = filtered.filter(item => {
      if (!item.date_taken) return false
      
      const itemDate = new Date(item.date_taken)
      itemDate.setHours(0, 0, 0, 0)
      
      if (dateRange.value.start) {
        const startDate = new Date(dateRange.value.start)
        startDate.setHours(0, 0, 0, 0)
        if (itemDate < startDate) return false
      }
      
      if (dateRange.value.end) {
        const endDate = new Date(dateRange.value.end)
        endDate.setHours(23, 59, 59, 999)
        if (itemDate > endDate) return false
      }
      
      return true
    })
  }

  // Apply search filter
  if (currentSearchQuery.value.trim()) {
    const query = currentSearchQuery.value.toLowerCase().trim()
    filtered = filtered.filter(item => {
      const employeeName = (item.employee?.user_details?.full_name || '').toLowerCase()
      const employeeEmail = (item.employee?.email || '').toLowerCase()
      const examName = (item.exam?.exam_name || '').toLowerCase()
      const moduleName = (item.exam?.module?.name || '').toLowerCase()
      
      return employeeName.includes(query) || 
             employeeEmail.includes(query) || 
             examName.includes(query) || 
             moduleName.includes(query)
    })
  }

  // Map to display format
  return filtered.map(item => ({
    ...item,
    employee_name: item.employee?.user_details?.full_name || item.employee?.email || '',
    exam_name: item.exam?.exam_name || '',
    module_name: item.exam?.module?.name || '',
    remarks_label: item.remarks_label || '', 
    exam_result_id: item.exam_result_id
  }))
})

// Group current exam results by employee + exam
const groupedExamResults = computed<GroupedExamResult[]>(() => {
  const groups = new Map<string, GroupedExamResult>()
  
  filteredExamResults.value.forEach(result => {
    // Create a unique key for grouping by employee + exam
    const employeeId = result.employee?.user_id || 0
    const examId = result.exam?.exam_id || 0
    const key = `${employeeId}_${examId}`
    
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        employeeId,
        examId,
        latestResult: result,
        results: []
      })
    }
    
    const group = groups.get(key)
    if (group) {
      group.results.push(result)
      
      // Update latest result if this one is more recent
      if (new Date(result.date_taken || 0) > new Date(group.latestResult.date_taken || 0)) {
        group.latestResult = result
      }
    }
  })
  
  // Sort groups by latest date (newest first) and sort results within each group
  return Array.from(groups.values())
    .sort((a, b) => {
      const dateA = new Date(a.latestResult.date_taken || 0).getTime()
      const dateB = new Date(b.latestResult.date_taken || 0).getTime()
      return dateB - dateA
    })
    .map(group => ({
      ...group,
      results: group.results.sort((a, b) => {
        // Sort by date taken (newest first)
        const dateA = new Date(a.date_taken || 0).getTime()
        const dateB = new Date(b.date_taken || 0).getTime()
        return dateB - dateA
      })
    }))
})

// Toggle current group expansion
const toggleCurrentGroup = (key: string) => {
  if (expandedCurrentGroups.value.has(key)) {
    expandedCurrentGroups.value.delete(key)
  } else {
    expandedCurrentGroups.value.add(key)
  }
}

// Filtered attempt history
const filteredAttemptHistory = computed(() => {
  let filtered = attemptHistory.value

  // Apply date range filter (using reset_date for history)
  if (dateRange.value.start || dateRange.value.end) {
    filtered = filtered.filter(item => {
      if (!item.reset_date) return false
      
      const itemDate = new Date(item.reset_date)
      itemDate.setHours(0, 0, 0, 0)
      
      if (dateRange.value.start) {
        const startDate = new Date(dateRange.value.start)
        startDate.setHours(0, 0, 0, 0)
        if (itemDate < startDate) return false
      }
      
      if (dateRange.value.end) {
        const endDate = new Date(dateRange.value.end)
        endDate.setHours(23, 59, 59, 999)
        if (itemDate > endDate) return false
      }
      
      return true
    })
  }

  // Apply search filter
  if (historySearchQuery.value.trim()) {
    const query = historySearchQuery.value.toLowerCase().trim()
    filtered = filtered.filter(item => {
      const employeeName = getEmployeeName(item).toLowerCase()
      const employeeEmail = getEmployeeEmail(item).toLowerCase()
      const examName = (item.exam?.exam_name || '').toLowerCase()
      const moduleName = (item.exam?.module?.name || '').toLowerCase()
      
      return employeeName.includes(query) || 
             employeeEmail.includes(query) || 
             examName.includes(query) || 
             moduleName.includes(query)
    })
  }

  return filtered
})

// Group attempt history by Restart Date, employee, and exam
const groupedAttemptHistory = computed<GroupedAttempt[]>(() => {
  const groups = new Map<string, GroupedAttempt>()
  
  filteredAttemptHistory.value.forEach(attempt => {
    // Create a unique key for grouping by reset_date + employee + exam
    const employeeId = attempt.employee?.user_id || 'unknown'
    const examId = attempt.exam?.exam_id || 'unknown'
    const resetDate = attempt.reset_date || 'unknown'
    const key = `${resetDate}_${employeeId}_${examId}`
    
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        resetDate: attempt.reset_date || '',
        resetDateFormatted: attempt.reset_date_formatted || '',
        resetBy: attempt.reset_by,
        attempts: []
      })
    }
    
    const group = groups.get(key)
    if (group) {
      group.attempts.push(attempt)
    }
  })
  
  // Sort groups by Restart Date (newest first) and sort attempts within each group
  return Array.from(groups.values())
    .sort((a, b) => {
      const dateA = new Date(a.resetDate).getTime()
      const dateB = new Date(b.resetDate).getTime()
      return dateB - dateA
    })
    .map(group => ({
      ...group,
      attempts: group.attempts.sort((a, b) => {
        // Sort by attempt number
        return (a.num_of_attempts || 0) - (b.num_of_attempts || 0)
      })
    }))
})

// Toggle group expansion
const toggleGroup = (key: string) => {
  if (expandedGroups.value.has(key)) {
    expandedGroups.value.delete(key)
  } else {
    expandedGroups.value.add(key)
  }
}

// Helper functions for attempt history
const getEmployeeName = (item: ExamAttemptHistory): string => {
  return item.employee?.user_details?.full_name || item.employee?.email || 'N/A'
}

const getEmployeeEmail = (item: ExamAttemptHistory): string => {
  return item.employee?.email || ''
}

// Date range preset functions
const setDateRangePreset = (preset: string) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  
  activePreset.value = preset
  
  switch (preset) {
    case 'today':
      dateRange.value.start = formatDateForInput(today)
      dateRange.value.end = formatDateForInput(today)
      break
      
    case 'week': {
      const startOfWeek = new Date(today)
      const day = startOfWeek.getDay()
      const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1) // Adjust when day is Sunday
      startOfWeek.setDate(diff)
      
      const endOfWeek = new Date(startOfWeek)
      endOfWeek.setDate(startOfWeek.getDate() + 6)
      
      dateRange.value.start = formatDateForInput(startOfWeek)
      dateRange.value.end = formatDateForInput(endOfWeek)
      break
    }
      
    case 'month': {
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      
      dateRange.value.start = formatDateForInput(startOfMonth)
      dateRange.value.end = formatDateForInput(endOfMonth)
      break
    }
      
    case 'year': {
      const startOfYear = new Date(today.getFullYear(), 0, 1)
      const endOfYear = new Date(today.getFullYear(), 11, 31)
      
      dateRange.value.start = formatDateForInput(startOfYear)
      dateRange.value.end = formatDateForInput(endOfYear)
      break
    }
  }
}

const isPresetActive = (preset: string) => {
  return activePreset.value === preset
}

const clearDateFilter = () => {
  dateRange.value.start = ''
  dateRange.value.end = ''
  activePreset.value = null
}

const formatDateForInput = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const formatDateRange = () => {
  if (dateRange.value.start && dateRange.value.end) {
    const start = new Date(dateRange.value.start).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })
    const end = new Date(dateRange.value.end).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })
    return `${start} - ${end}`
  } else if (dateRange.value.start) {
    return `From ${new Date(dateRange.value.start).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })}`
  } else if (dateRange.value.end) {
    return `Until ${new Date(dateRange.value.end).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    })}`
  }
  return ''
}

// View exam result details
const viewExamResult = (examResultId: number) => {
  console.log('🔍 Viewing exam result with ID:', examResultId)
  console.log('📋 Available exam results IDs:', examResults.value.map(r => r.exam_result_id))
  
  // Verify the ID exists in our data
  const resultExists = examResults.value.some(r => r.exam_result_id === examResultId)
  console.log('✅ Result exists in current data:', resultExists)
  
  if (!resultExists) {
    console.error('❌ Exam result ID not found in current data:', examResultId)
    return
  }
  
  router.push({ 
    name: 'ResultsExamView', 
    params: { id: examResultId.toString() } 
  })
}

// Helper for status color
function getStatusClass(remarks: number) {
  if (remarks === 1) return 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
  if (remarks === 0) return 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100'
  return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100'
}

onMounted(async () => {
  loading.value = true
  historyLoading.value = true
  
  try {
    console.log('📥 Loading exam results...')
    const response = await examResultService.getAllExamResults({ 
      sort_by: 'date_taken', 
      sort_order: 'desc' 
    })
    
    // Handle both paginated and non-paginated responses
    if (Array.isArray(response.data)) {
      examResults.value = response.data
    } else {
      examResults.value = response.data.data || []
    }
    
    console.log('✅ Loaded exam results:', examResults.value.length)
    console.log('📊 Exam results data:', examResults.value)
    
  } catch (err) {
    console.error('❌ Failed to load exam results:', err)
    examResults.value = []
  } finally {
    loading.value = false
  }

  // Load attempt history
  try {
    console.log('📥 Loading attempt history...')
    
    // Note: For now, we'll fetch all attempt history
    // You may want to implement per-employee filtering or pagination
    const historyResponse = await examResultService.getAllAttemptHistory({
      sort_by: 'reset_date',
      sort_order: 'desc'
    })
    
    attemptHistory.value = historyResponse.data || []
    
    console.log('✅ Loaded attempt history:', attemptHistory.value.length)
    console.log('📊 Attempt history data:', attemptHistory.value)
    
  } catch (err) {
    console.error('❌ Failed to load attempt history:', err)
    attemptHistory.value = []
  } finally {
    historyLoading.value = false
  }
})

// Ensure scores are displayed as whole numbers and calculate safe percentages
const formatScore = (score?: number | null) => {
  const n = Number(score ?? 0)
  if (Number.isNaN(n)) return 0
  return Math.round(n)
}

const calculatePercentage = (user?: number | null, total?: number | null) => {
  const u = Number(user ?? 0)
  const t = Number(total ?? 0)
  if (Number.isNaN(u) || Number.isNaN(t) || t <= 0) return 0
  const pct = Math.round((u / t) * 100)
  return Math.min(100, Math.max(0, pct))
}

const formatPercentage = (user?: number | null, total?: number | null) => {
  return calculatePercentage(user, total)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text mb-2" }, " Exam Result List "),
      _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Review the employee's exam results and attempt history. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'current')),
            class: _normalizeClass([
              activeTab.value === 'current'
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300',
              'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200'
            ])
          }, [
            _createVNode(_unref(ClipboardList), {
              class: _normalizeClass([
                activeTab.value === 'current' ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500',
                '-ml-0.5 mr-2 h-5 w-5'
              ])
            }, null, 8, ["class"]),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Current Results", -1)),
            (filteredExamResults.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([
                activeTab.value === 'current'
                  ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400'
                  : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
                'ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium'
              ])
                }, _toDisplayString(filteredExamResults.value.length), 3))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'history')),
            class: _normalizeClass([
              activeTab.value === 'history'
                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300',
              'group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200'
            ])
          }, [
            _createVNode(_unref(History), {
              class: _normalizeClass([
                activeTab.value === 'history' ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500',
                '-ml-0.5 mr-2 h-5 w-5'
              ])
            }, null, 8, ["class"]),
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "Attempt History", -1)),
            (filteredAttemptHistory.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([
                activeTab.value === 'history'
                  ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400'
                  : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
                'ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium'
              ])
                }, _toDisplayString(filteredAttemptHistory.value.length), 3))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_unref(Calendar), { class: "w-4 h-4 inline-block mr-1" }),
            _cache[12] || (_cache[12] = _createTextVNode(" Filter by Date Range ", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-xs text-secondary-text dark:text-secondary-dark-text mb-1" }, " From Date ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateRange.value.start) = $event)),
                type: "date",
                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm",
                placeholder: "Start date"
              }, null, 512), [
                [_vModelText, dateRange.value.start]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-xs text-secondary-text dark:text-secondary-dark-text mb-1" }, " To Date ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateRange.value.end) = $event)),
                type: "date",
                min: dateRange.value.start,
                disabled: !dateRange.value.start,
                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm disabled:opacity-50 disabled:cursor-not-allowed",
                placeholder: "End date"
              }, null, 8, _hoisted_10), [
                [_vModelText, dateRange.value.end]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-primary-text dark:text-primary-dark-text mb-2" }, " Quick Filters ", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (setDateRangePreset('today'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('today')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " Today ", 2),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (setDateRangePreset('week'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('week')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " This Week ", 2),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (setDateRangePreset('month'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('month')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " This Month ", 2),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (setDateRangePreset('year'))),
              class: _normalizeClass([
                'px-3 py-2 rounded-lg text-xs font-medium transition-all duration-200',
                isPresetActive('year')
                  ? 'bg-blue-600 text-white shadow-md'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ])
            }, " This Year ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(BaseButton, {
            text: "Clear",
            variant: "danger",
            size: "sm",
            icon: _unref(X),
            disabled: !dateRange.value.start && !dateRange.value.end,
            onClick: clearDateFilter
          }, null, 8, ["icon", "disabled"])
        ])
      ]),
      (dateRange.value.start || dateRange.value.end)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Active Filter:", -1)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(formatDateRange()), 1),
              _createElementVNode("span", _hoisted_17, " (" + _toDisplayString(filteredExamResults.value.length) + " results) ", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (activeTab.value === 'current')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(ClipboardList), { class: "w-5 h-5 text-blue-500" }),
                  _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " Current Results ", -1)),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(groupedExamResults.value.length) + " group" + _toDisplayString(groupedExamResults.value.length !== 1 ? 's' : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentSearchQuery).value = $event)),
                    type: "text",
                    placeholder: "Search by employee or exam...",
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm"
                  }, null, 512), [
                    [_vModelText, currentSearchQuery.value]
                  ])
                ])
              ])
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" }, null, -1),
                  _createElementVNode("p", { class: "mt-2 text-sm text-secondary-text dark:text-secondary-dark-text" }, "Loading exam results...", -1)
                ]))]))
              : (groupedExamResults.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_unref(ClipboardList), { class: "w-12 h-12 mx-auto text-gray-400 mb-3" }),
                    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "No exam results found.", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("table", _hoisted_29, [
                        _cache[26] || (_cache[26] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-gray-900" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "w-10 px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Employee "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Exam "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Attempts "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Latest Status "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Latest Date ")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedExamResults.value, (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: group.key
                            }, [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (toggleCurrentGroup(group.key)),
                                class: "hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
                              }, [
                                _createElementVNode("td", _hoisted_32, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-transform duration-200", { 'rotate-90': expandedCurrentGroups.value.has(group.key) }])
                                  }, [...(_cache[20] || (_cache[20] = [
                                    _createElementVNode("svg", {
                                      class: "w-5 h-5",
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M9 5l7 7-7 7"
                                      })
                                    ], -1)
                                  ]))], 2)
                                ]),
                                _createElementVNode("td", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(group.results[0].employee?.user_details?.full_name || group.results[0].employee?.email || 'N/A'), 1),
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(group.results[0].employee?.email), 1)
                                ]),
                                _createElementVNode("td", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(group.results[0].exam?.exam_name || 'N/A'), 1),
                                  (group.results[0].exam?.module)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(group.results[0].exam.module.name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_39, [
                                  _createElementVNode("span", _hoisted_40, _toDisplayString(group.results.length) + " attempt" + _toDisplayString(group.results.length !== 1 ? 's' : ''), 1)
                                ]),
                                _createElementVNode("td", _hoisted_41, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                          getStatusClass(group.latestResult.remarks)
                        ])
                                  }, _toDisplayString(group.latestResult.remarks_label), 3)
                                ]),
                                _createElementVNode("td", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(group.latestResult.date_taken_formatted), 1)
                                ])
                              ], 8, _hoisted_31),
                              (expandedCurrentGroups.value.has(group.key))
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                    _createElementVNode("td", _hoisted_45, [
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.results, (result, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: result.exam_result_id,
                                              class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow"
                                            }, [
                                              _createElementVNode("div", _hoisted_48, [
                                                _createElementVNode("div", _hoisted_49, [
                                                  _createElementVNode("div", _hoisted_50, _toDisplayString(index + 1), 1),
                                                  _createElementVNode("div", _hoisted_51, [
                                                    _createElementVNode("div", null, [
                                                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Score", -1)),
                                                      _createElementVNode("div", _hoisted_52, _toDisplayString(formatScore(result.user_score)) + "/" + _toDisplayString(formatScore(result.total_score)), 1),
                                                      _createElementVNode("div", _hoisted_53, _toDisplayString(formatPercentage(result.user_score, result.total_score)) + "% ", 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Attempt", -1)),
                                                      _createElementVNode("span", _hoisted_54, " #" + _toDisplayString(result.num_of_attempts), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Status", -1)),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass([
                                        'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                                        getStatusClass(result.remarks)
                                      ])
                                                      }, _toDisplayString(result.remarks_label), 3)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Date Taken", -1)),
                                                      _createElementVNode("div", _hoisted_55, _toDisplayString(result.date_taken_formatted), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Action", -1)),
                                                      _createElementVNode("button", {
                                                        onClick: _withModifiers(($event: any) => (viewExamResult(result.exam_result_id)), ["stop"]),
                                                        class: "text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors duration-200 p-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/20",
                                                        title: "View Exam Details"
                                                      }, [
                                                        _createVNode(_unref(Eye), { class: "w-5 h-5" })
                                                      ], 8, _hoisted_56)
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedExamResults.value, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.key,
                          class: "p-4"
                        }, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (toggleCurrentGroup(group.key)),
                            class: "bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm cursor-pointer active:shadow-md transition-shadow"
                          }, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("h3", _hoisted_62, _toDisplayString(group.results[0].employee?.user_details?.full_name || group.results[0].employee?.email || 'N/A'), 1),
                                  _createElementVNode("p", _hoisted_63, _toDisplayString(group.results[0].employee?.email), 1)
                                ]),
                                _createElementVNode("button", {
                                  class: _normalizeClass(["text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-transform duration-200 ml-2", { 'rotate-90': expandedCurrentGroups.value.has(group.key) }])
                                }, [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("svg", {
                                    class: "w-5 h-5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M9 5l7 7-7 7"
                                    })
                                  ], -1)
                                ]))], 2)
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, _toDisplayString(group.results[0].exam?.exam_name || 'N/A'), 1),
                                (group.results[0].exam?.module)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, " Module: " + _toDisplayString(group.results[0].exam.module.name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Attempts:", -1)),
                                  _createElementVNode("span", _hoisted_69, _toDisplayString(group.results.length) + " attempt" + _toDisplayString(group.results.length !== 1 ? 's' : ''), 1)
                                ]),
                                _createElementVNode("div", _hoisted_70, [
                                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Latest Status:", -1)),
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                          getStatusClass(group.latestResult.remarks)
                        ])
                                  }, _toDisplayString(group.latestResult.remarks_label), 3)
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Latest Date:", -1)),
                                  _createElementVNode("span", _hoisted_72, _toDisplayString(group.latestResult.date_taken_formatted), 1)
                                ])
                              ])
                            ])
                          ], 8, _hoisted_58),
                          (expandedCurrentGroups.value.has(group.key))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.results, (result, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: result.exam_result_id,
                                    class: "bg-gray-50 dark:bg-gray-900/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700"
                                  }, [
                                    _createElementVNode("div", _hoisted_74, [
                                      _createElementVNode("div", _hoisted_75, _toDisplayString(index + 1), 1),
                                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }, " Attempt Details ", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_76, [
                                      _createElementVNode("div", _hoisted_77, [
                                        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Score:", -1)),
                                        _createElementVNode("div", _hoisted_78, [
                                          _createElementVNode("div", _hoisted_79, _toDisplayString(formatScore(result.user_score)) + "/" + _toDisplayString(formatScore(result.total_score)), 1),
                                          _createElementVNode("div", _hoisted_80, _toDisplayString(formatPercentage(result.user_score, result.total_score)) + "% ", 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_81, [
                                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Attempt #:", -1)),
                                        _createElementVNode("span", _hoisted_82, " #" + _toDisplayString(result.num_of_attempts), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_83, [
                                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Status:", -1)),
                                        _createElementVNode("span", {
                                          class: _normalizeClass([
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                          getStatusClass(result.remarks)
                        ])
                                        }, _toDisplayString(result.remarks_label), 3)
                                      ]),
                                      _createElementVNode("div", _hoisted_84, [
                                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Date Taken:", -1)),
                                        _createElementVNode("span", _hoisted_85, _toDisplayString(result.date_taken_formatted), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (viewExamResult(result.exam_result_id)),
                                        class: "p-2 rounded-lg text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors",
                                        title: "View Details"
                                      }, [
                                        _createVNode(_unref(Eye), { class: "h-4 w-4" })
                                      ], 8, _hoisted_87)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])),
            (groupedExamResults.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, " Showing " + _toDisplayString(groupedExamResults.value.length) + " grouped exam" + _toDisplayString(groupedExamResults.value.length !== 1 ? 's' : '') + " with " + _toDisplayString(filteredExamResults.value.length) + " total result" + _toDisplayString(filteredExamResults.value.length !== 1 ? 's' : ''), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (activeTab.value === 'history')
      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_unref(History), { class: "w-5 h-5 text-blue-500" }),
                  _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " Attempt History ", -1)),
                  _createElementVNode("span", _hoisted_96, _toDisplayString(groupedAttemptHistory.value.length) + " reset" + _toDisplayString(groupedAttemptHistory.value.length !== 1 ? 's' : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((historySearchQuery).value = $event)),
                    type: "text",
                    placeholder: "Search by employee or exam...",
                    class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 text-sm"
                  }, null, 512), [
                    [_vModelText, historySearchQuery.value]
                  ])
                ])
              ])
            ]),
            (historyLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [...(_cache[37] || (_cache[37] = [
                  _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" }, null, -1),
                  _createElementVNode("p", { class: "mt-2 text-sm text-secondary-text dark:text-secondary-dark-text" }, "Loading attempt history...", -1)
                ]))]))
              : (groupedAttemptHistory.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _createVNode(_unref(Archive), { class: "w-12 h-12 mx-auto text-gray-400 mb-3" }),
                    _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "No attempt history found.", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("table", _hoisted_102, [
                        _cache[44] || (_cache[44] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-gray-900" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                              scope: "col",
                              class: "w-10 px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Employee "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Exam "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Attempts "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Restart Date "),
                            _createElementVNode("th", {
                              scope: "col",
                              class: "px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                            }, " Restart By ")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_103, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedAttemptHistory.value, (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: group.key
                            }, [
                              _createElementVNode("tr", {
                                onClick: ($event: any) => (toggleGroup(group.key)),
                                class: "hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
                              }, [
                                _createElementVNode("td", _hoisted_105, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-transform duration-200", { 'rotate-90': expandedGroups.value.has(group.key) }])
                                  }, [...(_cache[39] || (_cache[39] = [
                                    _createElementVNode("svg", {
                                      class: "w-5 h-5",
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M9 5l7 7-7 7"
                                      })
                                    ], -1)
                                  ]))], 2)
                                ]),
                                _createElementVNode("td", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, _toDisplayString(getEmployeeName(group.attempts[0])), 1),
                                  _createElementVNode("div", _hoisted_108, _toDisplayString(getEmployeeEmail(group.attempts[0])), 1)
                                ]),
                                _createElementVNode("td", _hoisted_109, [
                                  _createElementVNode("div", _hoisted_110, _toDisplayString(group.attempts[0].exam?.exam_name || 'N/A'), 1),
                                  (group.attempts[0].exam?.module)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(group.attempts[0].exam.module.name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_112, [
                                  _createElementVNode("span", _hoisted_113, _toDisplayString(group.attempts.length) + " attempt" + _toDisplayString(group.attempts.length !== 1 ? 's' : ''), 1)
                                ]),
                                _createElementVNode("td", _hoisted_114, [
                                  _createElementVNode("div", _hoisted_115, _toDisplayString(group.attempts[0].reset_date_formatted), 1)
                                ]),
                                _createElementVNode("td", _hoisted_116, [
                                  (group.attempts[0].reset_by)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(group.attempts[0].reset_by.name), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_118, "N/A"))
                                ])
                              ], 8, _hoisted_104),
                              (expandedGroups.value.has(group.key))
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_119, [
                                    _createElementVNode("td", _hoisted_120, [
                                      _createElementVNode("div", _hoisted_121, [
                                        _createElementVNode("div", _hoisted_122, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.attempts, (attempt, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: attempt.history_id,
                                              class: "bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow"
                                            }, [
                                              _createElementVNode("div", _hoisted_123, [
                                                _createElementVNode("div", _hoisted_124, [
                                                  _createElementVNode("div", _hoisted_125, _toDisplayString(index + 1), 1),
                                                  _createElementVNode("div", _hoisted_126, [
                                                    _createElementVNode("div", null, [
                                                      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Score", -1)),
                                                      _createElementVNode("div", _hoisted_127, _toDisplayString(formatScore(attempt.user_score)) + "/" + _toDisplayString(formatScore(attempt.total_score)), 1),
                                                      _createElementVNode("div", _hoisted_128, _toDisplayString(attempt.percentage_score) + "% ", 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Attempt", -1)),
                                                      _createElementVNode("span", _hoisted_129, " #" + _toDisplayString(attempt.num_of_attempts), 1)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Status", -1)),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass([
                                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                                      getStatusClass(attempt.remarks)
                                    ])
                                                      }, _toDisplayString(attempt.status), 3)
                                                    ]),
                                                    _createElementVNode("div", null, [
                                                      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "text-xs text-gray-500 dark:text-gray-400 mb-1" }, "Date Taken", -1)),
                                                      _createElementVNode("div", _hoisted_130, _toDisplayString(attempt.date_taken_formatted || 'N/A'), 1)
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedAttemptHistory.value, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.key,
                          class: "p-4"
                        }, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (toggleGroup(group.key)),
                            class: "bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm cursor-pointer active:shadow-md transition-shadow"
                          }, [
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("div", _hoisted_134, [
                                _createElementVNode("div", _hoisted_135, [
                                  _createElementVNode("h3", _hoisted_136, _toDisplayString(getEmployeeName(group.attempts[0])), 1),
                                  _createElementVNode("p", _hoisted_137, _toDisplayString(getEmployeeEmail(group.attempts[0])), 1)
                                ]),
                                _createElementVNode("button", {
                                  class: _normalizeClass(["text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-transform duration-200 ml-2", { 'rotate-90': expandedGroups.value.has(group.key) }])
                                }, [...(_cache[45] || (_cache[45] = [
                                  _createElementVNode("svg", {
                                    class: "w-5 h-5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M9 5l7 7-7 7"
                                    })
                                  ], -1)
                                ]))], 2)
                              ]),
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, _toDisplayString(group.attempts[0].exam?.exam_name || 'N/A'), 1),
                                (group.attempts[0].exam?.module)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_140, " Module: " + _toDisplayString(group.attempts[0].exam.module.name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("div", _hoisted_142, [
                                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Attempts:", -1)),
                                  _createElementVNode("span", _hoisted_143, _toDisplayString(group.attempts.length) + " attempt" + _toDisplayString(group.attempts.length !== 1 ? 's' : ''), 1)
                                ]),
                                _createElementVNode("div", _hoisted_144, [
                                  _cache[47] || (_cache[47] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Restart Date:", -1)),
                                  _createElementVNode("span", _hoisted_145, _toDisplayString(group.attempts[0].reset_date_formatted), 1)
                                ]),
                                (group.attempts[0].reset_by)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                      _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Restart Date:", -1)),
                                      _createElementVNode("span", _hoisted_147, _toDisplayString(group.attempts[0].reset_by.name), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 8, _hoisted_132),
                          (expandedGroups.value.has(group.key))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.attempts, (attempt, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: attempt.history_id,
                                    class: "bg-gray-50 dark:bg-gray-900/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700"
                                  }, [
                                    _createElementVNode("div", _hoisted_149, [
                                      _createElementVNode("div", _hoisted_150, _toDisplayString(index + 1), 1),
                                      _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }, " Attempt Details ", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_151, [
                                      _createElementVNode("div", _hoisted_152, [
                                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Score:", -1)),
                                        _createElementVNode("div", _hoisted_153, [
                                          _createElementVNode("div", _hoisted_154, _toDisplayString(formatScore(attempt.user_score)) + "/" + _toDisplayString(formatScore(attempt.total_score)), 1),
                                          _createElementVNode("div", _hoisted_155, _toDisplayString(attempt.percentage_score) + "% ", 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_156, [
                                        _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Attempt #:", -1)),
                                        _createElementVNode("span", _hoisted_157, " #" + _toDisplayString(attempt.num_of_attempts), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_158, [
                                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Status:", -1)),
                                        _createElementVNode("span", {
                                          class: _normalizeClass([
                        'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                        getStatusClass(attempt.remarks)
                      ])
                                        }, _toDisplayString(attempt.status), 3)
                                      ]),
                                      _createElementVNode("div", _hoisted_159, [
                                        _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Date Taken:", -1)),
                                        _createElementVNode("span", _hoisted_160, _toDisplayString(attempt.date_taken_formatted || 'N/A'), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])),
            (groupedAttemptHistory.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                  _createElementVNode("div", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, " Showing " + _toDisplayString(groupedAttemptHistory.value.length) + " grouped reset" + _toDisplayString(groupedAttemptHistory.value.length !== 1 ? 's' : '') + " with " + _toDisplayString(filteredAttemptHistory.value.length) + " total attempt" + _toDisplayString(filteredAttemptHistory.value.length !== 1 ? 's' : ''), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})